module.exports = __webpack_public_path__ + "static/media/btx_unlocked.6a6e6a06.svg";